import React, { createContext, useContext, useRef, useState } from "react";
const DocumentContext = createContext();

export const DocumentInfoProvider = ({ children }) => {
  const [documentInfo, setDocumentInfo] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [docID, setDocID] = useState(null);
  const [sheets, setSheets] = useState([]);
  const [savingData, setSavingData] = useState({
    isSaving: '',
    lastSavedDateTime: "",
    fileSize: 0,
  });
  const [isExternal, setIsExternal] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [isExternalAllow, setIsExternalAllow] = useState(false);
  const [isConflictModalVisible, setIsConflictModalVisible] = useState(false);
  const [serverData, setServerData] = useState(null);
  const isLoadingVersion = useRef(false);
  const [conflictPreviewVerion, setConflictPreviewVerion] = useState(null);

  return (
    <DocumentContext.Provider
      value=
      {{
        documentInfo, setDocumentInfo,
        isReadOnly, setIsReadOnly,
        userInfo, setUserInfo,
        docID, setDocID,
        sheets, setSheets,
        savingData, setSavingData,
        isExternal, setIsExternal,
        isVerified, setIsVerified,
        isAuthenticated, setIsAuthenticated,
        isExternalAllow, setIsExternalAllow,
        isConflictModalVisible, setIsConflictModalVisible,
        serverData, setServerData,
        isLoadingVersion,
        conflictPreviewVerion, setConflictPreviewVerion,
      }}
    >
      {children}
    </DocumentContext.Provider>
  );
};

export const useDocument = () => {
  return useContext(DocumentContext);
};
